import axios from 'axios';
import { API_DOMAIN } from 'config';

const API_BASE_URL = API_DOMAIN || process.env.REACT_APP_API_BASE_URL || 'http://localhost/backend/TradeFixNew';

/**
 * Get auction status for a car
 */
export const getAuctionStatus = async (carId, userId = null) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/car/getAuctionStatus/${carId}`, {
      params: userId ? { user_id: userId } : {},
    });
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      error: error.response?.data?.error || error.message || 'שגיאה בטעינת מצב המכרז'
    };
  }
};

/**
 * Submit auction bid
 */
export const submitAuctionBid = async (carId, userId, bidAmount) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/car/submitAuctionBid`, {
      car_id: carId,
      user_id: userId,
      bid_amount: bidAmount
    });
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      error: error.response?.data?.error || error.message || 'שגיאה בשליחת ההצעה'
    };
  }
};

/**
 * Get auction bids for a car (admin/provider only)
 */
export const getAuctionBids = async (carId, userId = null) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/car/getAuctionBids/${carId}`, {
      params: userId ? { user_id: userId } : {},
    });
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      error: error.response?.data?.error || error.message || 'שגיאה בטעינת ההצעות'
    };
  }
};

const auctionApi = {
  getAuctionStatus,
  submitAuctionBid,
  getAuctionBids
};

export default auctionApi;
